import { User, Package, FileText, Camera, CreditCard, Check, Banknote } from "lucide-react";

export default function StepConfirmation({ customer, items, total, monthlyTotal, documents, selfie, termsAccepted, paymentMethod, notes }) {
  const Section = ({ icon: Icon, title, badge, children }) => (
    <div className="crm-card overflow-hidden mb-5">
      <div className="px-5 py-3.5 flex items-center justify-between" style={{ borderBottom: "1px solid var(--crm-border)", background: "var(--crm-input-bg)" }}>
        <div className="flex items-center gap-2.5">
          <Icon className="w-4 h-4" style={{ color: "var(--crm-accent)" }} />
          <h3 className="text-sm font-bold" style={{ color: "var(--crm-text)" }}>{title}</h3>
        </div>
        {badge}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );

  return (
    <div data-testid="step-confirmation">
      <h2 className="crm-heading mb-2">Resumo da Venda</h2>
      <p className="text-sm mb-8" style={{ color: "var(--crm-text-muted)" }}>
        Revise todas as informações antes de confirmar.
      </p>

      <div className="max-w-2xl">
        {/* Customer */}
        <Section icon={User} title="Cliente">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "var(--crm-accent-subtle)", color: "var(--crm-accent)" }}>
              <User className="w-5 h-5" />
            </div>
            <div>
              <p className="text-base font-bold" style={{ color: "var(--crm-text)" }}>{customer?.name}</p>
              <p className="text-sm" style={{ color: "var(--crm-text-muted)" }}>{customer?.email} {customer?.phone && `· ${customer.phone}`}</p>
            </div>
          </div>
        </Section>

        {/* Products */}
        <Section icon={Package} title={`Produtos (${items.length} ${items.length === 1 ? "item" : "itens"})`}>
          <div className="space-y-3">
            {items.map((item) => (
              <div key={item.product_id} className="flex items-center justify-between py-2" style={{ borderBottom: "1px solid var(--crm-border)" }}>
                <div>
                  <p className="text-sm font-semibold" style={{ color: "var(--crm-text)" }}>{item.product_name}</p>
                  <p className="text-xs" style={{ color: "var(--crm-text-muted)" }}>Qtd: {item.quantity} x ¥{item.unit_price.toLocaleString()}</p>
                </div>
                <p className="text-base font-bold" style={{ color: "var(--crm-text)" }}>¥{(item.unit_price * item.quantity).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </Section>

        {/* TOTAL - Highlighted */}
        <div className="crm-card overflow-hidden mb-5" style={{ border: "2px solid var(--crm-accent)" }}>
          <div className="px-6 py-6" style={{ background: "var(--crm-accent-subtle)" }}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-bold uppercase tracking-wider mb-1" style={{ color: "var(--crm-text-muted)" }}>Total da Venda</p>
                {monthlyTotal > 0 && (
                  <p className="text-lg font-bold" style={{ color: "var(--crm-accent)" }}>+ ¥{monthlyTotal.toLocaleString()}<span className="text-sm font-normal">/mês</span></p>
                )}
              </div>
              <p className="text-4xl font-extrabold tracking-tight" style={{ color: "var(--crm-text)" }}>¥{total.toLocaleString()}</p>
            </div>
          </div>
        </div>

        {/* Checklist */}
        <div className="crm-card p-5 mb-5">
          <div className="space-y-3">
            {documents?.id_front && (
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}><Check className="w-3.5 h-3.5" /></div>
                <span className="text-sm" style={{ color: "var(--crm-text-secondary)" }}>Documentos enviados (Frente e Verso)</span>
              </div>
            )}
            {selfie && (
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}><Check className="w-3.5 h-3.5" /></div>
                <span className="text-sm" style={{ color: "var(--crm-text-secondary)" }}>Selfie enviada</span>
              </div>
            )}
            {termsAccepted && (
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}><Check className="w-3.5 h-3.5" /></div>
                <span className="text-sm" style={{ color: "var(--crm-text-secondary)" }}>Termos de serviço aceitos</span>
              </div>
            )}
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}><Check className="w-3.5 h-3.5" /></div>
              <span className="text-sm" style={{ color: "var(--crm-text-secondary)" }}>
                Pagamento: {paymentMethod === "manual" ? "Manual (Konbini / Transferência)" : "Cartão de Crédito"}
              </span>
            </div>
            {notes && (
              <div className="mt-2 pt-3" style={{ borderTop: "1px solid var(--crm-border)" }}>
                <p className="text-xs font-semibold mb-1" style={{ color: "var(--crm-text-muted)" }}>Observações:</p>
                <p className="text-sm" style={{ color: "var(--crm-text-secondary)" }}>{notes}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
